import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLocalizedPath } from "../../i18n/localizedPath";
import styles from "./jlptNotice.module.scss";

// The JLPT is run by the Japan Foundation and Japan Educational Exchanges and
// Services (https://www.jlpt.jp/e/faq/index.html, "Who conducts the JLPT?"),
// and since its 2010 revision it no longer publishes vocabulary/kanji/grammar
// lists per level (same FAQ, "Test Content Specifications"). That is why the
// N5-N1 labels on this site are our own, unofficial study aids.
//
//  - "full":   independence + unofficial levels (credits page, JLPT pages)
//  - "labels": only the level-label caveat (next to "Good for N5" badges)
//  - "footer": one line for the site footer, linking to the credits page
export type JlptNoticeVariant = "full" | "labels" | "footer";

type JlptNoticeProps = {
    variant?: JlptNoticeVariant;
    className?: string;
    /** Footer variant only: class for the link to the credits page. */
    linkClassName?: string;
};

function JlptNotice({ variant = "full", className, linkClassName }: JlptNoticeProps) {
    const { t } = useTranslation("common");
    const lp = useLocalizedPath();

    if (variant === "footer") {
        return (
            <p className={className}>
                <Trans
                    t={t}
                    i18nKey="jlptNotice.footer"
                    components={{ credits: <Link to={lp("/credits")} className={linkClassName} /> }}
                />
            </p>
        );
    }

    const classes = className ? `${styles.notice} ${className}` : styles.notice;
    return (
        <div className={classes} role="note" data-variant={variant}>
            {variant === "labels" ? (
                <p>{t("jlptNotice.labels")}</p>
            ) : (
                <>
                    <p>{t("jlptNotice.independent")}</p>
                    <p>{t("jlptNotice.levels")}</p>
                </>
            )}
        </div>
    );
}

export default JlptNotice;
